/* import __COLOCATED_TEMPLATE__ from './inline-insertion-pointer.hbs.js'; */
import Component from '@glimmer/component';
export default class InlineInsertionPointer extends Component {
  get insertionPointRect() {
    let hoverInfo = this.args.composer.state.hoverInfo;
    if (!hoverInfo) {
      return new DOMRect(0, 0, 0, 0);
    }
    let selection = this.args.composer.state.selectionInfo.rect || {
      top: 0,
      height: 0
    };
    let editorRect = hoverInfo.editorRect;
    let sectionRect = this.getSectionRect();
    // Display in regular location if not visual template
    // Display in regular location if section not found
    if (!this.args.composer.config?.tables?.containers || !sectionRect) {
      return new DOMRect(editorRect.x, selection.top, editorRect.width, selection.height);
    }

    // Display beside the body of visual template
    return new DOMRect(sectionRect.x, selection.top, sectionRect.width, selection.height);
  }

  // The DOMRect of the first section. Adjusted within iFrame
  getSectionRect() {
    let iFrame = document.getElementsByTagName('iframe')[0];
    let iFrameDoc = iFrame?.contentDocument;
    if (!iFrame || !iFrameDoc) {
      return;
    }
    let firstContainer = iFrameDoc.getElementsByClassName('container intercom-template-content')[0];
    if (!firstContainer) {
      return;
    }
    let iFrameRect = iFrame.getBoundingClientRect();
    let containerRect = firstContainer.getBoundingClientRect();
    return new DOMRect(iFrameRect.x + containerRect.x, iFrameRect.y + containerRect.y, containerRect.width, containerRect.height);
  }
}